module.exports = __webpack_public_path__ + "static/media/65.599797c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/65.wav
// module id = 4P0Y
// module chunks = 0